<template>
  <!-- 密码登录 -->
  <div class="login">
    <div class="input">
      <div class="logo">
        <p class="logo-1">森威立拍</p>
        <!-- <p class="logo-2">slogan</p> -->
      </div>
      <!-- 用户登录 -->
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h1 class="title">Hi，欢迎登录</h1>
        <div class="button-btn">
          <p
            class="code"
            @click="handlerPassword"
            type="checkbox"
            :class="{ 'code-password': !isType }"
          >
            密码登录
          </p>
          <p
            class="code"
            @click="handlerCodeLogin"
            :class="{ 'code-password': isType }"
          >
            验证码登录
          </p>
        </div>
        <el-form-item :prop="!isType ? 'account' : 'phone'" class="fromItem">
          <img
            class="fromItemImage"
            v-if="!isType"
            src="@/assets/img/user.png"
            alt=""
          />
          <img
            class="fromItemImage"
            v-else
            src="@/assets/img/user2.png"
            alt=""
          />
          <el-input
            v-if="!isType"
            type="text"
            v-model="ruleForm.account"
            auto-complete="off"
            placeholder="请输入账号"
          ></el-input>
          <el-input
            v-else
            type="text"
            v-model="ruleForm.phone"
            auto-complete="off"
            placeholder="请输入手机号"
          ></el-input>
          <!-- </div> -->
        </el-form-item>
        <!-- 验证码登录 -->
        <el-form-item prop="password" class="fromItem" v-if="!isType">
          <img class="fromItemImage" src="@/assets/img/password.png" alt="" />
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="密码"
            @keyup.native.enter="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" class="fromItem" v-else>
          <img class="fromItemImage" src="@/assets/img/password.png" alt="" />
          <el-input
            v-model="ruleForm.code"
            auto-complete="off"
            placeholder="请输入验证码"
            @keyup.native.enter="submitForm('ruleForm')"
          >
          </el-input>
          <span class="fromItem-code" @click="getCode">{{ btnText }}</span>
        </el-form-item>
        <!-- 忘记密码 -->
        <div class="forgotPassword" @click="handleGoForgotPassword">
          <p class="forget">忘记密码</p>
        </div>
        <el-form-item style="width: 100%">
          <el-button
            class="button-login"
            type="warning"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录
          </el-button>
        </el-form-item>
        <p @click="handleGoRegister" class="enroll">免费注册</p>
      </el-form>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Home/header";
import { getToken } from "@/utils/token";
import { rules } from "./model/rules.js";
export default {
  name: "Login",
  data() {
    return {
      isType: false,
      //定义loading默认为false
      logining: false,
      ruleForm: {
        //userName和password默认为空
        phone: "",
        password: "",
        code: "",
        account: "",
      },
      components: {
        Header,
      },
      //rules前端验证
      rules,
      btnText: "获取验证码",
      // 控制是否可以点击
      disabled: false,
    };
  },
  created() {},
  components: {},
  methods: {
    /**
     * 免费注册
     */
    handleGoRegister() {
      this.$store.commit("HANLE_IS_LOGIN_OR_REGISTER", 2);
    },
    /**
     * 忘记密码
     */
    handleGoForgotPassword() {
      this.$store.commit("HANLE_IS_LOGIN_OR_REGISTER", 3);
    },
    handleClaear() {
      this.ruleForm.code = "";
      this.ruleForm.password = "";
      this.ruleForm.phone = "";
    },
    // 密码登录
    handlerPassword() {
      this.isType = false;
      this.handleClaear();
      this.$refs.ruleForm.clearValidate();
    },
    // 验证码登录
    handlerCodeLogin() {
      this.isType = true;
      this.handleClaear();
      this.$refs.ruleForm.clearValidate();
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let _ruleForm;
          if (!this.isType) {
            _ruleForm = {
              // TODO:这里后期需要更改为account
              account: this.ruleForm.account,
              password: this.ruleForm.password,
            };
          } else {
            _ruleForm = {
              phone: this.ruleForm.phone,
              code: this.ruleForm.code,
            };
          }
          this.logining = true;
          await this.$store.dispatch("userLogin", _ruleForm);
          // let res = await login(this.ruleForm);
          // 获取token
          const token = getToken();
          if (token) {
            this.$store.commit("HANLE_VISIBLE_DIALOG", false);
            // 刷新页面
            this.$router.go(0);
            this.$message.success("登录成功");
          }
        } else {
          return false;
        }
        this.logining = false;
      });
    },

    // 获取验证码
    async getCode() {
      if (this.disabled) return;
      const { phone } = this.ruleForm;
      if (!phone) {
        this.$message.error("请输入手机号");
        return;
      }
      this.disabled = true;
      this.countDown();
      // 发送验证码
      const res = await this.$store.dispatch("getLoginCode", phone);
      if (res.code === 200) {
        this.$message.success("验证码已发送");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 验证码倒计时
    countDown() {
      let time = 60;
      let timer = setInterval(() => {
        time--;
        this.btnText = `${time}秒`;
        if (time === 0) {
          clearInterval(timer);
          this.btnText = "获取验证码";
          this.disabled = false;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.logo {
  font-size: 30px;
  // margin-left: 100px;
  margin-top: 80px;
  .logo-1 {
    color: rgb(162, 156, 152);
    font-weight: bold;
    font-size: 30px;
    font-weight: 600;
  }
}

.login {
  width: 100%;
  // min-height: 100vh;
  // background: url(@/assets/img/pic.png) no-repeat;
  background-size: cover;
  // background-color: #505458;
  display: flex;
  justify-content: center;
  align-items: center;
  .input {
    // width: 1199px;
    // height: 749px;
    // background-color: red;
    // background: url(@/assets/img/input.png);
  }
  .login-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-top: 10%;
    /* background-color: #112346; */
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
  }
  .login-container {
    position: relative;
    border-radius: 10px;
    margin: 0 auto;
    margin-right: 15px;
    width: 100%;
    padding: 30px 0 15px 0;
    text-align: left;
  }
}

.title {
  margin: 0px auto 40px auto;
  text-align: left;
  color: #505458;
  color: black;
}

.button-btn {
  display: flex;
  flex-direction: row;
  .code {
    cursor: pointer;
    margin-bottom: 35px;
    color: rgb(190, 180, 174);
    font-size: 20px;
    margin-right: 50px;
    &:hover {
      color: black;
    }
  }
  .code-password {
    color: black;
    font-weight: bold;
    &::after {
      content: "";
      display: block;
      bottom: 2px;
      width: 100%;
      height: 5px;
      background-color: #f5723b;
      margin: -8px 0 0 0;
    }
  }
}

.fromItem {
  border-radius: 10px;
  background: none;
  border: 1px solid #e0e0e0;
  .fromItemImage {
    width: 20px;
    height: 20px;
  }
  :deep .el-input__inner {
    border-radius: 30px !important;
  }
  :deep .el-form-item__content {
    background-color: #fff;
    border-radius: 10px !important;
    display: flex;
    align-items: center;
    padding: 0 10px;
    .el-icon-user {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding-left: 8px;
    }
  }
  :deep input {
    border: none !important;
  }
  .fromItem-code {
    width: 100px;
    text-align: right;
    color: rgb(235, 105, 24);
  }
  &:hover {
    cursor: pointer;
  }
}
.button-login {
  width: 100%;
  background-image: linear-gradient(
    to right,
    rgb(227, 146, 52),
    rgb(219, 96, 47)
  ) !important;
  border-radius: 10px;
  margin-top: 80px;
  color: #fff;
}
.enroll {
  text-align: center;
  color: rgb(231, 106, 42);
  cursor: pointer;
}

.forgotPassword {
  color: #e76a2a;
  cursor: pointer;
  position: absolute;
  right: 0;
  z-index: 1;
}
</style>
